import ChatBot from ".";

export default function ChatBotExamples() {
  return <ChatBot />;
}
